import CodeIcon from "@mui/icons-material/Code"; 
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import "./PythonSection.css";

function PythonSection() {
    return (
        <section className="course-content-section python-section">

            <div className="content-layout">

                {/* =================================================
                    MAIN CONTENT
                ================================================== */}

                <div className="content-main">

                    {/* <div className="content-label">
                        PYTHON PROGRAMMING
                    </div> */}

                    <h3>
                        Learn Python.
                        <span>
                            {" "}Build Anything.
                        </span>
                    </h3>

                    <p className="content-intro">
                        Python is one of the most versatile
                        programming languages, powering
                        automation, AI, data science and
                        modern application development.
                    </p>

                    <div className="benefits-grid">

                        <Benefit text="10,000+ Python jobs currently open across India." />

                        <Benefit text="Versatile language used in web development, automation, data analysis, AI and scripting." />

                        <Benefit text="Easy to Learn, Powerful to Use – Ideal for beginners and advanced developers." />

                        <Benefit text="Foundation for Machine Learning, AI and Data Science." />

                        <Benefit text="Used by leading technology companies including Google, Netflix and Instagram." />

                    </div>

                </div>


                {/* =================================================
                    SIDE CONTENT
                ================================================== */}

                <div className="content-side">

                    <div className="side-card python-card">

                        <div className="side-card-icon">
                            <CodeIcon />
                        </div>

                        <h4>
                            Python Training
                        </h4>

                        <p>
                            Build a strong programming
                            foundation and progress toward
                            advanced development.
                        </p>

                        <div className="python-highlights">

                            <span>
                                Beginner Friendly
                            </span>

                            <span>
                                Project Based
                            </span>

                            <span>
                                Industry Focused
                            </span>

                        </div>

                    </div>

                </div>

            </div>


           

        </section>
    );
}


/* =========================================================
   REUSABLE BENEFIT
========================================================= */

function Benefit({ text }) {

    return (
        <div className="benefit-item">

            <CheckCircleIcon />

            <span>
                {text}
            </span>

        </div>
    );
}


export default PythonSection;